import { Entity } from '../../services/sculkwire';
import { State as AppState } from '..';

export const selectEntities = (state: AppState): Entity[] => state.entities;
